<template>
  <div class="flex flex-col gap-4">
    <period-select v-model="filter.period_id" @change="loadBalanceTrxes" />
    <datatable
      :columns="[
        { id: 'date', name: 'Tanggal' },
        { id: 'code', name: 'Kode' },
        { id: 'trx_type', name: 'Tipe' },
        { id: 'description', name: 'Deskripsi' },
        { id: 'debt', name: 'Debit', theadClass: 'text-right' },
        { id: 'credit', name: 'Kredit', theadClass: 'text-right' },
        { id: 'balance', name: 'Saldo', theadClass: 'text-right' },
      ]"
      :total="balanceTrxes.meta.page.total"
      :perPage="balanceTrxes.meta.page.perPage"
      :currentPage="balanceTrxes.meta.page.currentPage"
      @pagechanged="onPageChange"
    >
      <template #tbody="{ classes }">
        <tr
          v-for="balanceTrx in balanceTrxes.data"
          :key="balanceTrx.id"
          :class="[classes.tr, 'bg-white']"
        >
          <td :class="classes.td">
            {{ balanceTrx.attributes.createdAt | formatDate }}
          </td>
          <td :class="classes.td">{{ balanceTrx.attributes.code }}</td>
          <td :class="classes.td">
            {{ getTrxTypeName(balanceTrx.attributes.trx_type) }}
          </td>
          <td :class="classes.td">
            {{ balanceTrx.attributes.description ?? '-' }}
          </td>
          <td :class="[classes.td, 'text-right']">
            <span v-if="balanceTrx.attributes[amountProp] < 0">{{
              Math.abs(balanceTrx.attributes[amountProp]) | toCurrency
            }}</span>
            <span v-else>0</span>
          </td>
          <td :class="[classes.td, 'text-right']">
            <span v-if="balanceTrx.attributes[amountProp] > 0">{{
              Math.abs(balanceTrx.attributes[amountProp]) | toCurrency
            }}</span>
            <span v-else>0</span>
          </td>
          <td :class="[classes.td, 'text-right']">
            {{ balanceTrx.attributes[balanceType] | toCurrency }}
          </td>
        </tr>
      </template>
    </datatable>
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import PeriodSelect from '../period/period-select.vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [requestMixin],
  components: { PeriodSelect },
  props: {
    officeId: String,
    balanceType: {
      type: String,
      default: 'order_balance',
    },
  },
  emits: ['update:loading'],
  data() {
    return {
      balanceTrxes: {
        data: [],
        meta: {
          page: {},
        },
      },
      filter: {
        period_id: null,
      },
      periodLoaded: false,
    };
  },
  watch: {
    balanceType() {
      this.loadBalanceTrxes();
    },
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    amountProp() {
      return {
        order_balance: 'order_balance_amount',
        order_debt_balance: 'order_debt_balance_amount',
        restock_balance: 'restock_amount',
        deposit_balance: 'deposit_amount',
        multiplied_deposit_balance: 'deposit_amount',
        overpayment_balance: 'overpayment_amount',
        debt_balance: 'debt_amount',
      }[this.balanceType];
    },
  },
  methods: {
    getTrxTypeName(type) {
      return {
        overpay_order: 'Sisa Bayar',
        pay_order: 'Pembayaran',
        refund_overpay_order: 'Pengembalian Sisa Bayar',
        refund_lesspay_order: 'Pengembalian Kurang Bayar',
        refund_order_balance: 'Pengembalian Pembayaran',
        topup_restock_balance: 'Topup Saldo Restock SC',
        draft: 'Penggunaan Saldo Restock SC Draft',
        topup_stockist: 'Topup Saldo Stockist',
        pay_order_bundle: 'Pembayaran Laporan Penjualan',
      }[type];
    },
    async loadBalanceTrxes(params) {
      this.$emit('update:loading', true);

      if (!this.periodLoaded) {
        await this.loadCurrentPeriod();
      }

      const [res, err] = await this.request(
        `/api/v1/offices/${this.officeId}/balance-trxes`,
        {
          params: {
            'page[size]': 10,
            'fields[balance-trxes]':
              'createdAt,code,trx_type,description,order_balance_amount,order_balance,restock_amount,restock_balance,order_debt_balance_amount,order_debt_balance,deposit_amount,deposit_balance,deposit_multiplier,multiplied_deposit_balance,overpayment_amount,overpayment_balance,debt_balance,debt_amount',
            sort: '-createdAt',
            'filter[period_id]': this.filter.period_id,
            'filter[balance_type]': this.balanceType,
            ...params,
          },
        }
      );

      if (!err) {
        this.balanceTrxes = res;
      }

      this.$emit('update:loading', false);
    },
    async loadCurrentPeriod() {
      const [res, err] = await this.request(
        '/api/v1/periods/-actions/get-current-period'
      );

      if (!err) {
        this.filter.period_id = res.data.id;

        this.periodLoaded = true;
      }
    },
    onPageChange(page) {
      this.loadBalanceTrxes({
        'page[number]': page,
      });
    },
  },
  created() {
    this.loadBalanceTrxes();
  },
};
</script>
